<template>
  <div class="container-fluid p-0" v-scroll-spy="{ data: 'section', offset: 0, time: 800, steps: 30 }">
    <section id="page-top">
      <banner
        :cover="profile.cover"
        :firstname="profile.firstname"
        :lastname="profile.lastname"
        :email="profile.email"
        :role="profile.role"
        :social="profile.social" />
    </section>

    <section class="resume-section dark p-3 py-5 p-lg-5 d-flex flex-column" id="about">
      <h2>About Me</h2>
      <div class="my-auto d-flex flex-lg-row flex-column">
        <div class="d-flex flex-column my-5">
          <h4 class="text-center">Experience</h4>
          <experience source="/api/works"
            :text-color="color.lightShades"
            :stack-color="color.lightShades"
            :bullet-color="color.main"
            class="mt-3 md-border-right" />
        </div>
        <div class="d-flex flex-column my-5">
          <h4 class="text-center">Education</h4>
          <education
            source="/api/studies"
            :text-color="color.lightShades"
            :stack-color="color.lightShades"
            :bullet-color="color.main"
            class="mt-3" />
        </div>
      </div>
    </section>

    <section class="resume-section light p-3 p-lg-5 d-flex flex-column" id="teaching">
      <h2 class="mb-5">Teaching</h2>
      <teaching-card-list
        source="/api/teaching"
        :columns="columns"
        :horizontal="horizontal"
        :card-color="color.darkShades"
        :text-color="color.darkShades"
        :card-text-color="color.lightShades"
        :accent-color="color.main"
        :border-color="color.lightShades" />
    </section>

    <section class="resume-section dark p-3 p-lg-5 d-flex flex-column" id="students">
      <h2 class="mb-5">Students</h2>
      <student-card-list
        source="/api/students"
        :columns="columns"
        :horizontal="horizontal"
        :card-color="color.lightShades"
        :text-color="color.darkShades"
        :card-text-color="color.darkShades"
        :accent-color="color.main"
        :border-color="color.darkShades" />
    </section>

    <section class="resume-section light p-3 p-lg-5 d-flex flex-column" id="projects">
      <h2 class="mb-5">Projects</h2>
      <project-card-list
        source="/api/projects"
        :columns="columns"
        :horizontal="horizontal"
        :card-color="color.darkShades"
        :text-color="color.darkShades"
        :card-text-color="color.lightShades"
        :accent-color="color.main"
        :border-color="color.lightShades" />
    </section>

    <section class="resume-section dark p-3 p-lg-5 d-flex flex-column" id="publications">
      <h2 class="mb-5">Publications</h2>
      <publication-card-list
        source="/api/publications"
        :columns="columns"
        :horizontal="horizontal"
        :card-color="color.lightShades"
        :text-color="color.darkShades"
        :card-text-color="color.darkShades"
        :accent-color="color.main"
        :border-color="color.darkShades" />
    </section>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

import { color } from '@/variables'

import Banner from '@/components/Banner'
import Education from '@/components/Education'
import Experience from '@/components/Experience'
import TeachingCardList from '@/components/TeachingCardList'
import StudentCardList from '@/components/StudentCardList'
import PublicationCardList from '@/components/PublicationCardList'
import ProjectCardList from '@/components/ProjectCardList'

export default {
  components: {
    'banner': Banner,
    'education': Education,
    'experience': Experience,
    'teaching-card-list': TeachingCardList,
    'student-card-list': StudentCardList,
    'publication-card-list': PublicationCardList,
    'project-card-list': ProjectCardList
  },

  data () {
    return {
      windowWidth: window.innerWidth,
      section: 0,
      profile: {
        cover: undefined,
        firstname: undefined,
        lastname: undefined,
        email: undefined,
        phone: undefined,
        mobile: undefined,
        role: undefined,
        address: {
          street: undefined,
          city: undefined,
          postcode: undefined,
          country: undefined
        },
        social: {
          facebook: undefined,
          twitter: undefined,
          linkedin: undefined,
          github: undefined,
          orcid: undefined,
          researchgate: undefined,
          googlescholar: undefined
        }
      },
      color
    }
  },

  watch: {
    section () {
      // const sections = document.querySelectorAll('section')
      // this.$router.replace({ name: 'home', hash: '#' + sections[this.section].id })
    }
  },

  mounted () {
    this.fetchProfile()

    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  },

  computed: {
    ...mapState(['$profile']),

    columns () {
      if (this.windowWidth > 1200) {
        return 3
      } else if (this.windowWidth > 576) {
        return 2
      } else {
        return 1
      }
    },

    horizontal () {
      if (this.windowWidth > 576) {
        return false
      }
      return true
    }
  },

  methods: {
    ...mapMutations(['increase$loading', 'decrease$loading']),

    fetchProfile () {
      /* this.increase$loading()
      fetch('/api/profile')
        .then(stream => stream.json())
        .then(data => { this.profile = data })
        .then(() => { this.decrease$loading() })
        .catch(error => { this.decrease$loading(); console.error(error) }) */
      this.profile = this.$profile
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';
@import '@/styles/_mixins.scss';

hr {
  border-top: 1px solid $light-shades;
}
section.resume-section {
  background-color: $white;
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
  .resume-item {
    .resume-content {}
    .resume-date {
      min-width: none;
    }
  }
}
@media (min-width: 768px) {
  section.resume-section {
    min-height: 100vh;
  }
}
@media (min-width: 992px) {
  section.resume-section {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
}

.md-border-right {
  border-right: 2px solid $light-shades;
  margin-right: calc(3.5rem/2);
  padding-right: calc(3.5rem/2);

  @media (max-width: 992px) {
    border-right: 0;
    margin-right: 0;
    padding-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue